import React from 'react';
import { Slider, Radio, Tooltip, InputNumber, Menu, Dropdown, Icon, Button, Input } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

export default class NumberEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
        super.componentWillMount();

        const v = this.props.source.value;
        if (!v)
            this.props.source.value = { mode: "auto", actualValue: "auto" };
    }

    onPxChange(e) {
        console.log(e);
        this.props.source.value = {
            mode: "custom",
            value: e,
            actualValue: e,
        };
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    onDropDownClick(e) {
        console.log(e);
    }

    onModeChange(e) {
        if (e === "auto") {
            this.props.source.value = {
                mode: "auto", actualValue: "auto"
            };
        }
        else if (e === "custom") {
            this.props.source.value = {
                mode: "custom",
                value: this.props.source.minValue === undefined ? 0 : this.props.source.minValue,
                actualValue: this.props.source.minValue === undefined ? 0 : this.props.source.minValue
            };
        }
    }

    render() {

        let value = this.props.source.value;
        if (!value)
            return;

        const mode = value.mode;
        value = value.value;

        const menu = (
            <Menu>
                <Menu.Item key="auto" onClick={e => this.onModeChange("auto")}>自动</Menu.Item>
                <Menu.Item key="custom" onClick={e => this.onModeChange("custom")}>手动</Menu.Item>
            </Menu>
        );

        return (
            <div className="property-editor--length">
                <div className="layout-h center hstretch">
                    {
                        mode === "auto" ? <Input
                            className="fill"
                            disabled /> : null
                    }
                    {
                        mode === "custom" ? <InputNumber
                            className="fill"
                            value={value}
                            min={this.props.source.minValue === undefined ? Number.MIN_SAFE_INTEGER : this.props.source.minValue}
                            max={this.props.source.maxValue === undefined ? Number.MAX_SAFE_INTEGER : this.props.source.maxValue}
                            onChange={e => this.onPxChange(e)} /> : null
                    }
                    <Dropdown overlay={menu} trigger={['click']}>
                        <Button
                            className='sp-left btn-bd-focus-none btn-pd-sm btn-layer-node btn-bk-hover btn-bd-none'
                            style={{ padding: '5px 5px' }}>
                            {mode === "auto" ? "自动" : (mode === "custom" ? "手动" : "")} <DownOutlined type="down" style={{ marginLeft: 3, fontSize: 10 }} />
                        </Button>
                    </Dropdown>
                </div>
            </div>
        );
    }
}

PropertyGridUtils.register("number", (source, propertyGrid) => <NumberEditor source={source} propertyGrid={propertyGrid} />);